import useCodonationAnalytics from './useCodonationAnalytics'

export default useCodonationAnalytics
